import { Divider } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { useSelector } from 'react-redux';
import ContentConstants from '../../../contentConstants';
import { DistributionType, EmailTemplatePropertiesUnderValidation } from '../../../models';
import { IApplicationState } from '../../../store';
import { useShouldDisableTestEmail } from '../../../utilities/hooks/index';
import { useAudienceEmails } from '../../../utilities/hooks/useAudienceEmails';
import { Label, LabelAbove } from '../../common';
import { InviteEmail } from '../email/InviteEmail';
import { ReminderEmails } from '../email/ReminderEmails';
import { SsoAttributeSection } from '../sso/SsoAttributeSection';
import { validateInvitationEmail } from './InvitationEmailValidator';

export const SSO = () => {
	const { audience } = useSelector((state: IApplicationState) => state.audienceDetails);
	const audienceEmail = useAudienceEmails(audience.audienceId, audience.surveyId);

	const shouldDisableTestEmailAndReminder = useShouldDisableTestEmail(audience.distributionType ?? DistributionType.SSO);

	const validateEmail = (distributionType?: DistributionType, fieldNames?: EmailTemplatePropertiesUnderValidation[]) => {
		const emailValidationErrors = validateInvitationEmail(
			audienceEmail.invitationEmail,
			distributionType,
			audienceEmail.invitationEmailValidationErrors,
			fieldNames,
		);
		audienceEmail.AddInvitationEmailValidationErrors(emailValidationErrors);
		return emailValidationErrors;
	};

	return (
		<>
			<Label size='md' className='tws-label'>
				{ContentConstants.DISTRIBUTIONOPTIONS_SSO_DESCRIPTION}
			</Label>
			<LabelAbove type='input' textIsHtml={true} text={ContentConstants.INSTRUCTIONALTEXT_DISTRIBUTION_SSO} />
			<Divider type='dashed' />
			<InviteEmail
				audience={audience}
				defaultEmailTemplates={audienceEmail.defaultEmailTemplates}
				invitationEmail={audienceEmail.invitationEmail}
				inviteEmailValidationError={audienceEmail.invitationEmailValidationErrors}
				isTemplateWarningModalOpen={audienceEmail.isTemplateWarningModalOpen}
				isMultiLanguageSurvey={audienceEmail.isMultiLanguageSurvey}
				selectedDefaultTemplate={audienceEmail.selectedDefaultTemplate}
				CloseTemplateWarningModal={audienceEmail.CloseTemplateWarningModal}
				selectDefaultTemplate={audienceEmail.SelectDefaultTemplate}
				onChange={audienceEmail.UpdateInvitationEmail}
				sendEmailModalOpen={audienceEmail.sendEmailModalOpen}
				shouldDisableTestEmail={shouldDisableTestEmailAndReminder}
				submitTemplateWarningModal={audienceEmail.SubmitTemplateWarningModal}
				toast={audienceEmail.Toast}
				toggleSendEmailModal={audienceEmail.ToggleSendEmailModal}
				validateInvitationEmail={validateEmail}
			/>
			<Divider type='dashed' />
			{
				<ReminderEmails
					addReminderToList={audienceEmail.AddReminderToList}
					addReminderEmailValidationErrors={audienceEmail.AddReminderEmailValidationErrors}
					audience={audience}
					columns={audienceEmail.reminderEmailColumns}
					deleteReminder={audienceEmail.DeleteReminder}
					invitationEmail={audienceEmail.invitationEmail}
					reminderEmails={audienceEmail.reminderEmails}
					reminderEmailValidationErrors={audienceEmail.reminderEmailValidationErrors}
					shouldDisableCreateReminder={shouldDisableTestEmailAndReminder}
					toast={audienceEmail.Toast}
				/>
			}
			<Divider type='dashed' />
			<SsoAttributeSection></SsoAttributeSection>
		</>
	);
};
